import axios from "axios";
import { API_URLS } from "../constants/ApiUrls";

export const fetchAllBookmarksApi = async (userId: string) => {
    const response = await axios.get(`${API_URLS.BOOKMARKS}/user/${userId}`);
    if (response.status === 200)
        return response.data;
    return [];
}

export const createNewBookmarkApi = async (request: any) => {
    const response = await axios.post(API_URLS.BOOKMARKS, request);
    if (response.status === 200)
        return response.data;
    return null;
}

export const deleteBookmarkApi = async (bookmarkId: number) => {
    const response = await axios.delete(`${API_URLS.BOOKMARKS}/${bookmarkId}`)
    if (response.status === 200)
        return response.data
    return null;
}